/**
 * 📜 DOCTRINE PRICING (27 mars 2026)
 *
 * La création de sondages est TOUJOURS gratuite et illimitée, pour tous
 * les plans (ANONYMOUS / FREE / SOLO). Il n'existe donc pas de "pollQuota"
 * à écouter ni à afficher.
 *
 * Les plafonds IA (0 / 10 / ∞) sont gérés localement dans les composants
 * qui appellent l'IA (via QuotaLimitModal).
 *
 * Ce composant est conservé comme no-op pour préserver l'emplacement de
 * montage dans l'arbre (App.tsx) et éviter une régression si un handler
 * global doit y être rebranché plus tard.
 */
export function GlobalQuotaHandler() {
  return null;
}
